module.exports = __webpack_public_path__ + "img/arrow.ecd0ae85.svg";